import * as React from "react"
import PropTypes from "prop-types"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import TagLink from "../components/tagLink"

import "./card.css"

const Card = ({ post, size }) => {
  const title = post.frontmatter.title || post.fields.meta.slug
  const mainImage = post.frontmatter.cover
    ? getImage(post.frontmatter.cover)
    : null

  // 記事に登録している重要度が15のタグを最大3つ表示
  const data = useStaticQuery(graphql`
    query CardQuery {
      allTagsJson(filter: { priority: { eq: "15" } }) {
        nodes {
          priority
          title
          name
          type
        }
      }
    }
  `)

  const allTagsData = data.allTagsJson.nodes
  const articleTags = post.frontmatter.tags
  let HightPriorityTags = []

  if (articleTags) {
    articleTags.forEach(tagName => {
      HightPriorityTags = [
        ...HightPriorityTags,
        ...allTagsData.filter(
          tag => tagName === tag.name
        ),
      ]
    })
  }

  const url = post.fields.meta.slug
  const isExternal = /^https?:\/\//.test(url)
  
  return (
    <article
      className={`post-list-item rounded-xl shadow-lg overflow-hidden hover:shadow-xl ${size === "l" && `w-full flex-shrink-0 flex-grow-0 max-w-md`}`}
      itemScope
      itemType="http://schema.org/Article"
    >
      {isExternal ? (
        <a href={url} itemProp="url" className="hover:opacity-80">
          {mainImage ? <GatsbyImage image={mainImage} alt={title} /> : null}
        </a>
      ) : (
        <Link to={url} itemProp="url" className="hover:opacity-80">
          {mainImage ? <GatsbyImage image={mainImage} alt={title} /> : null}
        </Link>
      )}
  
      <div className="p-4 lg:p-6 card-content">
        {isExternal ? (
          <a href={url} itemProp="url">
            <h2 className="text-base font-bold text-brandNavy mb-2 hover:opacity-80 lg:text-xl">
              <span itemProp="headline">{title}</span>
            </h2>
          </a>
        ) : (
          <Link to={url} itemProp="url">
            <h2 className="text-base font-bold text-brandNavy mb-2 hover:opacity-80 lg:text-xl">
              <span itemProp="headline">{title}</span>
            </h2>
          </Link>
        )}
  
        <div className="text-textGray-60 text-sm">{post.frontmatter.date}</div>
        <div className="pt-4 flex flex-wrap flex-gap-1">
          {HightPriorityTags.length > 0
            ? HightPriorityTags.map(tag => (
                <TagLink
                  name={tag.name}
                  title={tag.title}
                  key={`${post.id}-${tag.name}`}
                  size={"s"}
                />
              ))
            : null}
        </div>
      </div>
    </article>
  )
}

Card.defaultProps = {
  size: "m",
}

Card.propTypes = {
  post: PropTypes.object.isRequired,
  size: PropTypes.string,
}

export default Card
